import { render, staticRenderFns } from "./floatbutton.vue?vue&type=template&id=379ef5ba"
import script from "./floatbutton.vue?vue&type=script&lang=js"
export * from "./floatbutton.vue?vue&type=script&lang=js"
import style0 from "./floatbutton.vue?vue&type=style&index=0&id=379ef5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports